import React, { createContext, useContext, useState, useEffect } from 'react';
import { Project } from '../types/project';
import { api } from '../utils/api';

interface ProjectContextType {
  currentProject: Project | null;
  setCurrentProject: (project: Project | null) => void;
  loading: boolean;
}

const ProjectContext = createContext<ProjectContextType>({
  currentProject: null,
  setCurrentProject: () => {},
  loading: false,
});

export const useProject = () => useContext(ProjectContext);

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentProject, setCurrentProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const projectId = localStorage.getItem('currentProjectId');
    if (projectId) {
      setLoading(true);
      api.get(`/projects/${projectId}`)
        .then(response => {
          setCurrentProject(response.data);
        })
        .catch(() => {
          localStorage.removeItem('currentProjectId');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const handleSetCurrentProject = (project: Project | null) => {
    setCurrentProject(project);
    if (project) {
      localStorage.setItem('currentProjectId', project.id.toString());
    } else {
      localStorage.removeItem('currentProjectId');
    }
  };

  return (
    <ProjectContext.Provider
      value={{
        currentProject,
        setCurrentProject: handleSetCurrentProject,
        loading,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
}; 